import { CAMPAIGN_MEMO_MAX_LENGTH } from '@/common/constants'
import { normalizeLineEndings } from '@/common/utils'

export function countMemoLength(text: string): number {
  return normalizeLineEndings(text).length
}

export function isMemoOverLimit(text: string): boolean {
  return countMemoLength(text) > CAMPAIGN_MEMO_MAX_LENGTH
}

export function formatMemoCounter(text: string): string {
  return `${countMemoLength(text).toLocaleString()}/${CAMPAIGN_MEMO_MAX_LENGTH.toLocaleString()}`
}

export function getMemoErrorMessage(text: string): string {
  if (!isMemoOverLimit(text)) {
    return ''
  }
  return `文字数は${CAMPAIGN_MEMO_MAX_LENGTH.toLocaleString()}文字以下にしてください。`
}
